import { cn } from '@util/index';
export default function DynamicSkeleton({
  fullWidth = true,
  fullHeight = false,
  height,
  width,
}: {
  fullWidth?: boolean;
  fullHeight?: boolean;
  height: number;
  width?: number;
}) {
  return (
    <div
      className={cn(
        'animate-pulse rounded-[1.6rem] bg-brand-light-gray',
        fullWidth ? 'w-full' : `w-[${width}px]`,
        fullHeight ? 'h-full' : `h-[${height}px]`
      )}
    ></div>
  );
}
